import { describeDisagreement, } from "./tracks";
function today(now) {
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
}
function emptyTally(day) {
    return { disagreements: {}, day };
}
let tally = emptyTally(today(new Date()));
function current(now = new Date()) {
    const day = today(now);
    if (tally.day !== day)
        tally = emptyTally(day);
    return tally;
}
const warned = new Set();
const WARNED_MAX = 200;
export function resetTrackReport(now = new Date()) {
    tally = emptyTally(today(now));
    warned.clear();
}
export function reportTrackDisagreements(disagreements, assetId, now) {
    var _a;
    if (disagreements.length === 0)
        return;
    const t = current(now);
    const id = (assetId !== null && assetId !== void 0 ? assetId : "").trim() || "unidentified-title";
    const fresh = [];
    for (const d of disagreements) {
        const key = `${id}|${d.code}|${d.languages.join(",")}`;
        if (warned.has(key))
            continue;
        if (warned.size >= WARNED_MAX) {
            const oldest = warned.values().next().value;
            if (oldest !== undefined)
                warned.delete(oldest);
        }
        warned.add(key);
        fresh.push(d);
        t.disagreements[d.code] = ((_a = t.disagreements[d.code]) !== null && _a !== void 0 ? _a : 0) + 1;
    }
    if (fresh.length === 0)
        return;
    try {
        console.warn(`[player] track_labels_disagree title=${id} ${fresh
            .map(describeDisagreement)
            .join(" ")}`);
    }
    catch {
    }
}
export function currentTrackTally(now) {
    const t = current(now);
    return Object.keys(t.disagreements).length > 0
        ? { day: t.day, disagreements: { ...t.disagreements } }
        : null;
}
